import { IngredientType } from '../../../interfaces/post_ingredients'
import { IPost } from '../../../interfaces/posts'

export const filterIngredients = (post: IPost, ingredient: IngredientType) => {
  if (post.global) {
    return ingredient.type !== 'map' && ingredient.type !== 'inclusionReason'
  }
  return true
}
